module.exports = __webpack_public_path__ + "img/android-submit-vote.a2d30cfb.png";